export default "__VITE_ASSET__f8bb4870__"